import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

function ResetPasswordEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const t = searchParams.get('token');
    if (t) {
      setToken(t);
      verifyToken(t);
    } else {
      setVerifying(false);
    }
  }, [searchParams]);

  const verifyToken = async (t) => {
    try {
      const res = await fetch(`${API_URL}/password-reset/email/verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: t })
      });
      setTokenValid(res.ok);
    } catch (e) {
      setTokenValid(false);
    } finally {
      setVerifying(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password.length < 4) {
      toast.error('Şifre en az 4 karakter olmalı');
      return;
    }
    if (password !== confirmPassword) {
      toast.error('Şifreler eşleşmiyor');
      return;
    }
    
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/password-reset/email/confirm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password })
      });
      
      if (res.ok) {
        setSuccess(true);
        toast.success('Şifreniz değiştirildi!');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        const data = await res.json();
        toast.error(data.detail || 'Hata oluştu');
      }
    } catch (e) {
      toast.error('Sunucuya bağlanılamadı');
    } finally {
      setLoading(false);
    }
  };

  if (verifying) {
    return (
      <div className="login-container">
        <div className="login-box" style={{textAlign: 'center'}}>
          <div style={{fontSize: '40px', marginBottom: '20px'}}>⏳</div>
          <h2>Doğrulanıyor...</h2>
        </div>
      </div>
    );
  }

  if (!tokenValid) {
    return (
      <div className="login-container">
        <div className="login-box" style={{textAlign: 'center'}}>
          <div style={{fontSize: '64px', marginBottom: '20px'}}>❌</div>
          <h2>Geçersiz Link</h2>
          <p style={{color: '#666', margin: '20px 0'}}>
            Bu link geçersiz veya süresi dolmuş.
          </p>
          <Link to="/forgot-password-email" style={{
            display: 'inline-block',
            padding: '12px 24px',
            background: 'linear-gradient(135deg, #667eea, #764ba2)',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px',
            marginTop: '10px'
          }}>
            Yeni Link Al
          </Link>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="login-container">
        <div className="login-box" style={{textAlign: 'center'}}>
          <div style={{fontSize: '64px', marginBottom: '20px'}}>✅</div>
          <h2>Başarılı!</h2>
          <p style={{color: '#666'}}>Giriş sayfasına yönlendiriliyorsunuz...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <div className="login-logo">🔐</div>
          <h1>Yeni Şifre Belirle</h1>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Yeni Şifre</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="En az 4 karakter"
              required
              minLength={4}
            />
          </div>
          
          <div className="form-group">
            <label>Şifre Tekrar</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Şifreyi tekrar girin"
              required
            />
          </div>
          
          {password && confirmPassword && password !== confirmPassword && (
            <p style={{color: '#f44336', fontSize: '13px', margin: '-10px 0 10px'}}>
              Şifreler eşleşmiyor
            </p>
          )}
          
          <button type="submit" className="login-button" disabled={loading || password !== confirmPassword}>
            {loading ? 'Kaydediliyor...' : 'Şifremi Değiştir'}
          </button>
        </form>
        
        <div style={{textAlign: 'center', marginTop: '20px'}}>
          <Link to="/login" style={{color: '#667eea', textDecoration: 'none', fontSize: '14px'}}>
            ← Giriş sayfasına dön
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordEmail;